export default __webpack_public_path__ + "static/media/Twitter.1908555b.svg";